import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import './azar-mehr-unicode.css';
import { store } from './redux/store';

const root = ReactDOM.createRoot(document.getElementById('root'));

fetch('/api/v2/configs/react')
  .then((res) => res.json())
  .then(({ result }) => {
    if (result) {
      window.env = {};
      Object.entries(result).map(([key, value]) => {
        window.env[key] = value;
      });
    }
  })
  .catch(console.log)
  .finally(() => {
    import('./i18n')
      .catch((err) => {
        console.warn('i18n import failed — continuing without i18n', err);
        return null;
      })
      .then(() => {
        root.render(
          <Provider store={store}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </Provider>,
        );
      });
  });
